import Api from './api';

const FiscContratosService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/fisccontratos/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/fisccontratos/buscar?${params}`)
        return response
    }
}

export default FiscContratosService;